<template>
  <kst-container class="kst-item-export-list">
    <kst-form
      :failure="failureList"
      :failureInit="failureInit"
      :hide-body="!!formWarnings"
      :hide-footer="!!formWarnings"
      :title="title"
      :warnings="formWarnings"
    >
      <Export
        ref="refExport"
        :access="access"
        :searchData="searchData"
        @error="handleError"
      />

      <kst-section export-mode>
        <kst-check disabled v-model="searchData.WithList" :label="labelOptList"/>
      </kst-section>
      
      <template #bottom-left>
        <kst-button action-mode
          class="is-primary"
          tag="button"
          :module="Model.Module"
          :moduleType="Model.ModuleType.ExportList"
          @click="handleExport"
        />
      </template>
    </kst-form>
  </kst-container>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterMixin from "@/mixins/RouterMixin.js";
import Info from "../DailyReportInfo.js";
import Model from "../DailyReportModel.js";

import Export from "../Export/DailyReportExport_List";

export default {
  mixins: [AxiosMixin, RouterMixin],
  components: {
    Export
  },
  data: () => ({
    Model: Model,
    searchData: {},
    access: {},
    isListLoading: true,
    // error
    failureInit: null,
    failureList: null,
    formWarnings: null
  }),
  computed: {
    labelOptList() {
      return Info.Export.List.Excel.Option.List;
    },
    title() {
      return Info.Export.List.Excel.Title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.formWarnings = null;
      this.access = Model.createAccess();
      this.initSearch();
    },
    initSearch() {
      this.searchData = {
        WarehouseID: this.getUrlParam(this.$kst.Enum.Param.WarehouseID),
        Date: this.getUrlParam(this.$kst.Enum.Param.Date),
        WithList: true,
      };
    },

    handleError(message) {
      this.failureList = message;
    },
    handleExport() {
      this.failureList = null;
      this.$refs.refExport.exportExcel();
    }
  }
}
</script>